"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var DragHandle =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DragHandle, _PureComponent);

  function DragHandle() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DragHandle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DragHandle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAddEventListeners", function (isTouch) {
      if (isTouch) {
        // Only add touch events if the event is a touch-based event.
        document.addEventListener('touchcancel', _this.onDragEnd);
        document.addEventListener('touchend', _this.onDragEnd);
        document.addEventListener('touchmove', _this.onDragMove);
      } else {
        // Only add mose events if the event is a mouse-based event.
        document.addEventListener('mouseleave', _this.onDragEnd);
        document.addEventListener('mousemove', _this.onDragMove);
        document.addEventListener('mouseup', _this.onDragEnd);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragEnd", function (event) {
      var onDragEnd = _this.props.onDragEnd;
      var isTouch = event.type === 'touchcancel' || event.type === 'touchend';

      var _ref = isTouch ? event.changedTouches[0] : event,
          pageX = _ref.pageX,
          pageY = _ref.pageY,
          screenX = _ref.screenX,
          screenY = _ref.screenY;

      onDragEnd && onDragEnd(pageX, pageY, screenX, screenY);

      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else if (document.selection) {
        document.selection.empty();
      }

      _this.onRemoveEventListeners(event);

      event.stopPropagation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragMove", function (event) {
      var onDragMove = _this.props.onDragMove;
      var isTouch = event.type === 'touchmove';

      var _ref2 = isTouch ? event.changedTouches[0] : event,
          pageX = _ref2.pageX,
          pageY = _ref2.pageY,
          screenX = _ref2.screenX,
          screenY = _ref2.screenY;

      onDragMove && onDragMove(pageX, pageY, screenX, screenY);
      event.stopPropagation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragStart", function (event) {
      var onDragStart = _this.props.onDragStart;
      var isTouch = event.type === 'touchstart';

      var _ref3 = isTouch ? event.changedTouches[0] : event,
          pageX = _ref3.pageX,
          pageY = _ref3.pageY,
          screenX = _ref3.screenX,
          screenY = _ref3.screenY;

      onDragStart && onDragStart(pageX, pageY, screenX, screenY);

      _this.onAddEventListeners(isTouch);

      event.stopPropagation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRemoveEventListeners", function () {
      // Remove all event listeners, in the event that both were added.
      document.removeEventListener('touchcancel', _this.onDragEnd);
      document.removeEventListener('touchend', _this.onDragEnd);
      document.removeEventListener('touchmove', _this.onDragMove);
      document.removeEventListener('mouseleave', _this.onDragEnd);
      document.removeEventListener('mousemove', _this.onDragMove);
      document.removeEventListener('mouseup', _this.onDragEnd);
    });
    return _this;
  }

  (0, _createClass2.default)(DragHandle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          onDragEnd = _this$props.onDragEnd,
          onDragMove = _this$props.onDragMove,
          onDragStart = _this$props.onDragStart,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "onDragEnd", "onDragMove", "onDragStart"]); // For now, this is a plain div with hooks to make it handle dragging.
      // However, a more accessible solution would be to use an input element of type range.
      // In the interim, the role of "separator" is thrown on the div to quiet the lint warnings.

      /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

      return _react.default.createElement("div", (0, _extends2.default)({
        className: className,
        role: "separator",
        onMouseDown: this.onDragStart,
        onTouchStart: this.onDragStart
      }, rest));
      /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
    }
  }]);
  return DragHandle;
}(_react.PureComponent);

exports.default = DragHandle;
(0, _defineProperty2.default)(DragHandle, "propTypes", {
  className: _propTypes.default.string,
  onDragEnd: _propTypes.default.func,
  onDragMove: _propTypes.default.func,
  onDragStart: _propTypes.default.func
});